import { kitordercontentdetails } from '../Data/testData';

const ExpandableKitOrderContentLayout = ({ row }: { row: any }) => {


    return (
        <>
            <div className="bg-transparent p-2">
                <table className="detailtable table count-details-nested-list mb-0">
                    <thead>
                        <tr className="custom-header-blue">
                            <th></th>
                            <th>Line#</th>
                            <th className="ps-3">Item Code</th>
                            <th className="ps-3">Item Name</th>
                            <th className="ps-3">UOM</th>
                            <th className="ps-3">Item Qty</th>
                        </tr>
                    </thead>
                    <tbody>
                        {kitordercontentdetails.map((detail, detailIndex) => (
                            <tr className="" key={detailIndex}>
                                <td className="bg-transparent"></td>
                                <td className="bg-transparent">{detail.line}</td>
                                <td className="bg-transparent ps-3">{detail.item_code}</td>
                                <td className="bg-transparent ps-3">{detail.item_name}</td>
                                <td className="bg-transparent ps-3">{detail.UOM}</td>
                                <td className="bg-transparent ps-3">{detail.item_qty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )

}
export default ExpandableKitOrderContentLayout;
